<template>
  <div class="text-xs-center pt-4">
    <h1 class="mb-3">Calendario Appuntamenti</h1>
    <v-container>

      <v-layout row class="mb-4 justify-center">
        <v-flex xs12 md4 >
          <v-select
            :items="nomeLashmaker" 
            v-model="nomecognome" 
            label="Seleziona Lashmaker" 
            @change="filtraLashmaker(nomecognome)"
          ></v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
          <!-- IL TUO CALENDARIO  --> 
          <v-flex xs12 md3>
              <v-date-picker
              v-model="picker"  
              :allowed-dates="allowedDates"
              class="my-2"
              :min="minDate" 
              @change="aggiornaAppuntamenti()" 
              locale="it"     
              ></v-date-picker>
          </v-flex>

          <v-flex xs12 md9 class="pl-5">
              <v-card flat class="pa-3 ma-2 appuntamenti-folder" 
                      v-for="(appuntamento, index) in appuntamentiData" 
                      :key="appuntamento.id">
                  <v-layout v-if="appuntamento.tipo=='appuntamento'" row wrap>

                      <v-flex xs12 md8>
                        <v-layout row wrap>
                          <v-flex xs12 md3 text-xs-center>
                              <div class="caption grey--text my-3">Data</div>
                              <div>{{ appuntamento.data }}</div>
                          </v-flex>  
                          <v-flex xs12 md3 text-xs-center>
                              <div class="caption grey--text my-3">Orario</div>
                              <div>{{ appuntamento.ora }}</div>
                          </v-flex>
                          <v-flex xs12 md3 text-xs-center>
                              <div class="caption grey--text my-3">Servizio</div>
                              <div>{{ appuntamento.nomeServizio }}</div>
                          </v-flex>      
                          <v-flex xs12 md3 text-xs-center>
                              <div class="caption grey--text my-3">Durata</div>
                              <div>{{ appuntamento.durataServizio }}</div>
                          </v-flex>                              
                          <v-flex xs12 md3 text-xs-center>
                              <div class="caption grey--text my-3">Effetto</div>
                              <div>{{ appuntamento.effetto }}</div>
                          </v-flex>
                          <v-flex xs12 md3 text-xs-center>
                              <div class="caption grey--text my-3">Luxury</div>
                              <div v-if="appuntamento.luxury">Si</div>
                              <div v-else>No</div>
                          </v-flex>                                                  
                          <v-flex xs12 md3 text-xs-center>
                              <div class="caption grey--text my-3">Lashmaker</div>
                              <div>{{ appuntamento.nomeLashmaker }} {{ appuntamento.cognomeLashmaker }}</div>
                          </v-flex>
                          <v-flex xs12 md3 text-xs-center>
                              <div class="caption grey--text my-3">Cliente</div>
                              <div>{{ appuntamento.nomeCliente }} {{ appuntamento.cognomeCliente }}</div>
                          </v-flex>                                                             
                          <v-flex xs12 md3 text-xs-center>
                              <div class="caption grey--text my-3">Telefono</div>
                              <div>{{ appuntamento.telefono}}</div>
                          </v-flex>                                 
                          <v-flex xs12 md3 text-xs-center>
                              <div class="caption grey--text my-3">Email</div>
                              <div>{{ appuntamento.email}}</div>
                          </v-flex>    
                          <v-flex xs12 text-xs-center>
                              <div class="caption grey--text my-3">Note</div>
                              <div>{{ appuntamento.note}}</div>
                          </v-flex>    

                          <v-flex xs12 text-xs-center> <!-- @focus="indexFocused = index" -->
                              <v-text-field label="Aggiorna Note"             
                                @keypress.enter="salvaNota(appuntamento.id, index)"
                                v-model="noteAppuntamento">
                              </v-text-field>
                          </v-flex>                                                  

                          <!-- <template>
                            
                            <v-dialog v-model="dialog1" persistent max-width="600px">
                              <template v-slot:activator="{ on }">
                                <v-btn color="primary" dark v-on="on">Aggiorna note</v-btn>
                              </template>
                              <v-card>
                                <v-card-title>
                                  <span class="headline">Modifica Note</span>
                                </v-card-title>
                                <v-card-text>
                                  <v-container>
                                    <v-text-field   
                                      v-model="noteAppuntamento" label="Note">
                                    </v-text-field>
                                  </v-container>
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn color="blue darken-1" text @click="dialog1 = false">Close</v-btn>
                                  <v-btn color="blue darken-1" text @click="salvaNota(appuntamento.id, index)">Save</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          
                          </template> -->                    

                        </v-layout>

                      </v-flex>

                      <v-flex class="align-self-center" xs6 md2 text-xs-center>
                          <v-btn fab :disabled="appuntamento.stato == 'Approvato'" color="green" @click ="approvaAppuntamento(appuntamento.id, index)">
                          <v-icon dark>done</v-icon>
                          </v-btn>
                      </v-flex>                        

                      <v-flex class="align-self-center" xs6 md2 text-xs-center>
                          <v-btn  fab color="lash" @click="removeAppuntamento(appuntamento.id, index) ">
                          <v-icon dark>delete</v-icon>
                          </v-btn>
                      </v-flex>

                  </v-layout>

                  <v-layout v-else-if="appuntamento.tipo=='evento'" row wrap>

                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs12 md2 text-xs-center>
                              <div class="caption grey--text my-3">Nome Evento</div>
                              <div>{{ appuntamento.nomeEvento }}</div>
                          </v-flex>  
                          <v-flex xs12 md2 text-xs-center>
                              <div class="caption grey--text my-3">Data</div>
                              <div>{{ appuntamento.data }}</div>
                          </v-flex>
                          <v-flex xs12 md1 text-xs-center>
                              <div class="caption grey--text my-3">Ora</div>
                              <div>{{ appuntamento.ora }}</div>
                          </v-flex>      
                          <v-flex xs12 md1 text-xs-center>
                              <div class="caption grey--text my-3">Durata</div>
                              <div>{{ appuntamento.durataServizio }}</div>
                          </v-flex>                              
                          <v-flex xs12 md2 text-xs-center>
                              <div class="caption grey--text my-3">Luogo</div>
                              <div>{{ appuntamento.luogoEvento }}</div>
                          </v-flex>
                          <v-flex xs12 md2 text-xs-center>
                              <div class="caption grey--text my-3">Note</div>
                              <div>{{ appuntamento.noteEvento }}</div>
                          </v-flex>
                          <v-flex class="align-self-center" xs6 md2 text-xs-center>
                              <v-btn fab color="lash" @click="removeAppuntamento(appuntamento.id, index) ">
                              <v-icon dark>delete</v-icon>
                              </v-btn>
                          </v-flex>                          
                        </v-layout>
                      </v-flex>                        

                  </v-layout>
              </v-card>
          </v-flex>

          <v-flex xs12 md3>
            <template>
                <v-dialog v-model="dialog" persistent max-width="600px">
                  <template v-slot:activator="{ on }">
                      <v-btn flat left v-on="on">
                        <span>Aggiungi Evento</span>
                        <v-icon right>event</v-icon>
                      </v-btn> 
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Crea Evento</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                          <v-flex text-xs-center class="mt-2">
                            <v-text-field 
                              label="Nome Evento*"
                              v-model="nomeEvento"
                              required
                            >
                            </v-text-field>
                          </v-flex>
                          <!-- SELEZIONA LASHMAKER/STUDIO -->
                          <v-flex text-xs-center class="mt-2">
                              <v-combobox class="mt-4" 
                                :items="nomeLashmaker"
                                v-model="nomecognome"  
                                label="Seleziona Lashmaker/Studio" 
                                spellcheck="false">
                              </v-combobox>
                          </v-flex>                            
                          <v-flex text-xs-center class="mt-2">
                            <v-text-field 
                              label="Data Evento*"
                              type="date"
                              v-model="dataEvento"
                              required
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex text-xs-center class="mt-2">
                            <v-text-field 
                              label="Ora Evento" 
                              type="time"
                              v-model="oraEvento"
                              required>
                            </v-text-field>    
                          </v-flex>                           
                          <v-flex text-xs-center class="mt-2">
                            <v-text-field 
                              label="Durata Evento" 
                              type="time"
                              v-model="durataEvento">
                            </v-text-field>    
                          </v-flex> 
                          <v-flex text-xs-center class="mt-2">
                            <v-text-field 
                              label="Luogo Evento" 
                              type="text"
                              v-model="luogoEvento">
                            </v-text-field>    
                          </v-flex>         
                          <v-flex text-xs-center class="mt-2">
                            <v-text-field 
                              label="Note" 
                              type="text"
                              v-model="noteEvento">
                            </v-text-field>    
                          </v-flex>                                                                                                        
                      </v-container>
                      <small>*campi obbligatori</small>
                    </v-card-text>
                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                      <v-btn color="blue darken-1" text @click="salvaEvento()">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

            </template>
          </v-flex>        

      </v-layout>

    </v-container>
  </div>
</template>

<script>
import format from "date-fns/format"
import fb from "@/fb"
export default {
  data() {
    return {
      appuntamenti: [],
      appuntamentiData: [],
      lashmaker: [],
      nomecognome: "", 
      loading: false,
      nome: "",
      cognome: "",
      snackbar: false,
      openDate: new Date().toISOString().substr(0, 10),
      picker: "",
      dialog: false,
      dialog1: false,
      nomeEvento: "",
      dataEvento: "",
      oraEvento: "",
      durataEvento: "00:00",
      luogoEvento: "",
      noteAppuntamento: "",
      noteEvento: "",
      indexFocused: false
    }
  },
  computed: {      
    minDate() {
      return this.openDate ? format(this.openDate, "YYYY-MM-DD") : ""
    },
    nomeLashmaker() { 
      return this.lashmaker.map(lashmaker => {
        return lashmaker.nome + " " +lashmaker.cognome
      })
    }
  },
  methods: {
    salvaEvento() {
        let nome = this.nomecognome.split(" ")[0]
        let cognome = this.nomecognome.split(" ")[1]
        const appuntamenti = {
          nomeEvento: this.nomeEvento,
          data: format(this.dataEvento, "YYYY-MM-DD"),
          ora: this.oraEvento,
          nomeLashmaker: nome,
          cognomeLashmaker: cognome,
          durataServizio: this.durataEvento,
          luogoEvento: this.luogoEvento,
          noteEvento: this.noteEvento,
          tipo : "evento"
        }
        fb.db.collection('appuntamenti').add(appuntamenti).then(
          this.appuntamentiData.push(appuntamenti),
          this.nomeEvento = "",
          this.dataEvento = "",
          this.durataEvento = "00:00",
          this.luogoEvento = "",
          this.noteEvento = "",
          this.dialog = false
        )   
    },
    /*disattivaNote(index) {
      console.log(index, this.indexFocused)
      if (index == this.indexFocused) {
        return false
      } else {
        return true
      }
    },*/
    salvaNota(id, index) {
      //console.log(index, this.indexFocused)
      fb.db.collection('appuntamenti').doc(id).update({
        note : this.noteAppuntamento
      }).then( 
        this.dialog1 = false,
        this.appuntamentiData[index].note = this.noteAppuntamento,
        this.noteAppuntamento = "",
        this.aggiornaAppuntamenti
      )

    },
    allowedDates(val) {       
        let val1 = format(val, "YYYY-MM-DD")
        return this.appuntamenti.find(res => res.data == val1)
    },        
    aggiornaAppuntamenti() {
        let data = format(this.picker, "YYYY-MM-DD")
        this.appuntamentiData = this.appuntamenti.filter(app => app.data == data)    
    },
    approvaAppuntamento(id, index) {
      //fb.auth.sendEmail(this.appuntamentiData[index].email)
      fb.db.collection('appuntamenti').doc(id).update({
        stato : "Approvato"
      })
      this.appuntamentiData[index].stato = "Approvato"
      //console.log(index, this.appuntamenti[index].stato, this.appuntamentiData[index].stato)
    },
    removeAppuntamento(id, index) {
      fb.db.collection('appuntamenti').doc(id).delete()
      this.appuntamentiData.splice(index, 1)    
    },
    filtraLashmaker(nomecognome) {
      let nome = nomecognome.split(" ")[0]
      let cognome = nomecognome.split(" ")[1]
      this.appuntamentiData = this.appuntamentiData.filter(res => {
        return res.nomeLashmaker == nome && res.cognomeLashmaker == cognome
      })
    }
  },
  beforeCreate() {
    fb.db.collection('appuntamenti')  //.where('data', '==', this.picker)
         .orderBy('ora')
         .onSnapshot(res => {
        const changes = res.docChanges()
        changes.forEach(change => {
        if (change.type === "added")  {
          this.appuntamenti.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }
      })
    })
    fb.db.collection('lashmaker')
         .onSnapshot(res => {
        const changes = res.docChanges()
        changes.forEach(change => {        
        if (change.type === "added")  {
          this.lashmaker.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }
      })
    })

  }
}
</script>

<style>
.appuntamenti-folder{background: #fff; border-left: 4px solid #FF9E80!important; border-bottom: 1px solid #dddddd!important;}
</style>

